import { FsTypeBase } from '@types';
import React from 'react';
import { useQueryParamState } from 'src/modules/links';

const TYPE_ID_PARAM_KEY = 'typeId';

export const useFsTypes = <TextType>() => {
  const [types, setTypes] = React.useState<FsTypeBase<TextType>[]>([]);
  const [typeId, setTypeId] = useQueryParamState(TYPE_ID_PARAM_KEY);

  const type = types.find((t) => t.id === typeId);

  function handleTypeChange(typeId: string) {
    if (typeId) {
      setTypeId(TYPE_ID_PARAM_KEY, typeId);
    }
  }

  return {
    types,
    setTypes,
    typeId: typeId || undefined,
    setTypeId: handleTypeChange,
    type,
  };
};

export function usePeriods(paramKey: string) {
  const [periods, setPeriods] = React.useState<FsTypeBase<string>[]>([]);
  const [periodId, setPeriodId] = useQueryParamState(paramKey);

  const period = periods.find((p) => p.id === periodId);

  function handlePeriodChange(periodId: string) {
    if (periodId) {
      setPeriodId(paramKey, periodId);
    }
  }

  return {
    periods,
    setPeriods,
    periodId: periodId || undefined,
    setPeriodId: handlePeriodChange,
    period,
  };
}
